import React from "react";
import { connect } from "react-redux";

import Navbar from "../../../../../_components/common/Navbar";
import SideNavBar from "../../../../../_components/common/SideNavBar";
import {
  orgAdminAreaData,
  AnalyzeData
} from "../../../OrgAdminArea/SidebarData";
import AnalysisNavBar from "../../../../../_components/common/AnalysisNavBar";
import DynamicGradientTables from "../../../../../_components/common/DynamicGradientTables";
import {
  CONCERN,
  ADVANTAGE,
  NEGATIVE_IMPACT,
  POSITIVE_IMPACT,
  classNameCustom,
  button_data,
  single_button_data,
  arrow_button_data
} from "./CompatibilityExtensionData";
import CircularButtonGroup from "../../../../../_components/common/CircularButtonGroup";
// import ReactSpeedometer from "react-d3-speedometer";
import ReactSpeedometer from "../../../../../_components/common/CustomSpeedometer/CustomSpeedometer";
import { Collapse, Button } from "reactstrap";
import { global_data } from "../../globalData";
import dataFormater from "../../dataFormater";
import "./index.css";
import ModularTooltip from "../../../../../_components/common/ModularTooltip";

import PopupCompitability from './detailPopup/popupCompitability';

import { userListAction } from "../../../../../_actions/Analyze/userList.action";
import { teamFitmentAction } from "../../../../../_actions/Analyze/teamFitmnt.action";
import {
  saveModulePermissionsAction,
  orgAdminAction,
  saveTeamDetailsAction,
  analyseActions
} from "../../../../../_actions";

import compatibilityIcon from "../../../../../images/compatibilityIcon.png";
import team_fitment_team from "../../../../../images/team_fitment_team.png";
import team_fitment_indi from "../../../../../images/team_fitment_indi.png";

class Compatibility extends React.Component {
  constructor(props) {
    super(props);
    this.renderCustomComponent = this.renderCustomComponent.bind(this);
    this.state = {
      teamName: "",
      teamId: localStorage.getItem("teamId"),
      teamMembers: [],
      getPaUserPermissionListResponse: "",
      selection_id: null,
      selected_route_parameter: null,
      traceable_value: null,
      Tooltip: false,
      doubleGauge: false,
      collapse_individual: false,
      collapse_role: false,
      collapse_team: false,
      filterApplied: null,
      navData: [],
      filterData: null,
      select_data: [
        {
          name: "Choose Individual",
          id: null
        },
        {
          name: "Alison Burges",
          id: 1
        },
        {
          name: "Ladis Mas Was Hands",
          id: 2
        }
      ],
      class_name: {
        main_container: "d-flex flex-row flex-wrap align-items-start col-12",
        container: {
          container: "d-flex flex-column col-sm-3 col-md-3 col-lg-3 w-100 p-1",
          style: {
            margin: 1
          }
        },
        header_container: {
          header_container: "w-100 py-2 my-1",
          style: {
            paddingLeft: 30,
            margin: 1
          }
        },
        header_container_non_routable: {
          header_container_non_routable:
            "d-flex flex-column align-items-center justify-content-start text-white ",
          header_container_non_routable_title:
            "font-class-compatibility-title font-weight-bold py-1",
          header_container_non_routable_optional:
            "font-class-compatibility-optional"
        },
        child_container: {
          child_container: "d-flex flex-column col-12 flex-wrap w-100 px-0",
          style: {
            margin: 1
          }
        },
        child_content_container: {
          child_content_container:
            "d-flex col-sm-12 col-md-12 col-lg-12 p-1 px-2 justify-content-between my-1 text-dark text-center ",
          child_content_container_header:
            "font-weight-bold py-1 font-class-compatibility-title",
          child_content_container_desc: "font-weight-bold font-italic",
          child_content_container_footer: ""
        }
      },
      data: [],
      detailed_class_name: {
        main_container:
          "d-flex flex-row flex-wrap align-items-center col-12 px-0",
        container: {
          container:
            "d-flex flex-column col-sm-12 col-md-12 col-lg-12 w-100 p-1",
          style: {
            margin: 1
          }
        },
        header_container: {
          header_container: "w-90 py-3 mx-1 my-1 background-image-recorrection",
          style: {
            paddingLeft: 20,
            margin: 1
          }
        },
        header_container_non_routable: {
          header_container_non_routable:
            "d-flex flex-row align-items-center text-white",
          header_container_non_routable_title: "",
          header_container_non_routable_optional: ""
        },
        child_container: {
          child_container: "d-flex flex-column justify-content-between px-0 impact-popup",
          style: {
            margin: 1
          }
        },
        child_content_container: {
          child_content_container: "d-flex px-0  text-dark",
          child_content_container_header: "font-weight-bold ",
          child_recomended_points_container: "font-weight-bold font-size-12",
          child_recomended_points_header: "font-weight-bold",
          child_recomended_points_list_container:
            "child_recomended_points_list_container_adjust pad-x-0_4rem",
          child_recomended_points_list_items: "font-italic",
          child_content_container_desc: "",
          child_content_container_footer: "font-size-10"
        }
      },
      selected_name: "",
      selected_team_array: [],
      individual_data_copy: [],
      individual_data: [],
      team_data: [],
      team_data_loader: true,
      role_checkpoint: [
        {
          role: "Team Member",
          active: false,
          role_key: "team_member"
        },
        {
          role: "Team Leader",
          active: false,
          role_key: "team_leader"
        },
        {
          role: "Both",
          active: false,
          role_key: "both"
        }
      ],
      active_role: null,
      active_name: null,
      selectedTeams: false,

      currentPos: null,
      selected_team_name: ""
    };
  }

  componentDidUpdate(prev, prevState) {
    if (prev.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
      if (this.props.headPerLoadingResonse !== "") {
        const temp = [];
        if (localStorage.getItem("is_pa_user") == "true") {
          temp.push({
            navName: "Analyze",
            link: `/organisation/${this.props.match.params.id}/user`
          });
        }
        if (localStorage.getItem("is_org_admin") == "true") {
          temp.push({
            navName: "Org Admin Area",
            link: `/organisation/${this.props.match.params.id}/org-admin`
          });
        }
        if (localStorage.getItem("is_success") == "true") {
          temp.push({
            navName: "Super Admin Area",
            link: `/organisation/${this.props.match.params.id}/super-admin`
          });
        }
        this.setState({ navData: temp });
      }
    }

    if (
      prev.saveAssesorGroupListResponse !=
      this.props.saveAssesorGroupListResponse
    ) {
      if (this.props.saveAssesorGroupListResponse != "") {
        const { team_members } = this.props.saveAssesorGroupListResponse;
        // const { order_by_name } = this.props.userListResponse.data.members
        // var filtered_arr = this.filterFun(order_by_name,team_members)
        var altered_team_members = [];
        team_members
          .filter(val => (val.filtered !== undefined ? val.filtered : true))
          .map(ob => {
            altered_team_members.push({
              id: ob.assessment.id,
              name: ob.user__full_name ? ob.user__full_name : ob.user_email,
              isChecked: false
            });
          });
        this.setState(
          {
            individual_data_copy: altered_team_members,
            individual_data: altered_team_members,
            filterData: this.props.saveAssesorGroupListResponse,
            filterApplied: null,
            active_name: null
          },
          () => {
            let individualFound = false;
            altered_team_members.map(member => {
              if (member.id == this.props.match.params.individual) {
                individualFound = true;
              }
            });

            if (!individualFound) {
              this.props.history.push(
                `/organisation/${this.props.match.params.id}/user/compability`
              );
            }
          }
        );
      }
    }

    if (
      prev.getPaAnanlyzeTeamListResponse !=
      this.props.getPaAnanlyzeTeamListResponse
    ) {
      if (this.props.getPaAnanlyzeTeamListResponse != "") {
        var temp_arr = [];
        var reformatdata = [];
        var tableData = this.props.getPaAnanlyzeTeamListResponse.data;
        for (var key in tableData) {
          if (tableData.hasOwnProperty(key)) {
            reformatdata = reformatdata.concat(tableData[key]);
          }
        }

        var sortedArray = reformatdata.sort(function(a, b) {
          return (
            a.team_type - b.team_type || a.team_name.localeCompare(b.team_name)
          );
        });

        sortedArray.map(obj => {
          // if(localStorage.getItem('teamId') != obj.id) {
          //     temp_arr.push({
          //         name: `${obj.team_name}`,
          //         id: obj.id,
          //         isChecked: false
          //     })
          // }
          temp_arr.push({
            name: `${obj.team_name}`,
            id: obj.id,
            isChecked: false
          });
          this.setState(
            { team_data: temp_arr, team_data_loader: false },
            () => {}
          );
        });
      }
    }
    if (prev.teamFitmentResponse != this.props.teamFitmentResponse) {
      if (this.props.teamFitmentResponse != "") {
        // this.setState({data: dataFormater(this.props,this.props.teamFitmentResponse.data,'team_fitment_single_team_team_member'),filterApplied: "one"},() => {
        // })
      }
    }

    if (prev.saveAssesorIdsResponse !== this.props.saveAssesorIdsResponse) {
      if (this.props.saveAssesorIdsResponse !== "") {
        this.getDynamicTeamDataUsingRoutes();
      }
    }

    // if(prev.match.params.individual !== this.props.match.params.individual || prev.match.params.selectedTeam !== this.props.match.params.selectedTeam || prev.match.params.role !== this.props.match.params.role) {
    //     this.getDynamicTeamDataUsingRoutes()
    // }
  }

  filterFun = (wholeArray, current_team_array) => {
    var filteredArray = wholeArray.filter(function(array_el) {
      return (
        current_team_array.filter(function(anotherOne_el) {
          return anotherOne_el.assessment.id == array_el.id;
        }).length == 0
      );
    });
    return filteredArray;
  };

  componentDidMount() {
    this.getDynamicTeamDataUsingRoutes();

    // this.props.dispatch(userListAction.userListDataAction({"analytics_org_id":this.props.match.params.id}))
    this.props.dispatch(
      saveModulePermissionsAction.requestModulePermissionsHandler()
    );
    if (this.props.saveModulePermissionsResponse !== "") {
      this.props.saveModulePermissionsResponse.filter((data, i) => {
        if (data.module_list__module_name === "Team  Fitment") {
          return data;
        }
      }).length === 0 &&
        this.props.history.push(
          `/organisation/${this.props.match.params.id}/user/dashboard`
        );
    }

    //header
    const temp = [];
    if (localStorage.getItem("is_pa_user") == "true") {
      temp.push({
        navName: "Analyze",
        link: `/organisation/${this.props.match.params.id}/user`
      });
    }
    if (localStorage.getItem("is_org_admin") == "true") {
      temp.push({
        navName: "Org Admin Area",
        link: `/organisation/${this.props.match.params.id}/org-admin`
      });
    }
    if (localStorage.getItem("is_success") == "true") {
      temp.push({
        navName: "Super Admin Area",
        link: `/organisation/${this.props.match.params.id}/super-admin`
      });
    }
    this.setState({ navData: temp });

    //
    if (this.props.saveAssesorGroupListResponse != "") {
      const { team_members } = this.props.saveAssesorGroupListResponse;
      // const { order_by_name } = this.props.userListResponse.data.members
      // var filtered_arr = this.filterFun(order_by_name,team_members)
      var altered_team_members = [];
      team_members
        .filter(val => (val.filtered !== undefined ? val.filtered : true))
        .map(ob => {
          altered_team_members.push({
            id: ob.assessment.id,
            name: ob.user__full_name ? ob.user__full_name : ob.user_email,
            isChecked: false
          });
        });
      this.setState({
        individual_data_copy: altered_team_members,
        individual_data: altered_team_members,
        filterData: this.props.saveAssesorGroupListResponse
      });
    }

    //
    if (this.props.getPaAnanlyzeTeamListResponse != "") {
      var temp_arr = [];
      var reformatdata = [];
      var tableData = this.props.getPaAnanlyzeTeamListResponse.data;
      for (var key in tableData) {
        if (tableData.hasOwnProperty(key)) {
          reformatdata = reformatdata.concat(tableData[key]);
        }
      }

      var sortedArray = reformatdata.sort(function(a, b) {
        return (
          a.team_type - b.team_type || a.team_name.localeCompare(b.team_name)
        );
      });

      sortedArray.map(obj => {
        // if(localStorage.getItem('teamId') != obj.id) {
        //     temp_arr.push({
        //         name: `${obj.team_name}`,
        //         id: obj.id,
        //         isChecked: false
        //     })
        // }
        temp_arr.push({
          name: `${obj.team_name}`,
          id: obj.id,
          isChecked: false
        });
        this.setState({ team_data: temp_arr }, () => {});
      });
    }
  }

  getDynamicTeamDataUsingRoutes = () => {
    if (
      this.props.match.params.individual &&
      this.props.match.params.selectedTeam &&
      this.props.match.params.role
    ) {
      this.props.dispatch(
        teamFitmentAction.teamFitmentDataAction(
          {
            team_member_id: this.props.match.params.individual,
            team_assessment_id: this.props.match.params.selectedTeam.split("_"),
            role: this.props.match.params.role,
            relation_group_ids: this.props.saveAssesorIdsResponse.assessorIds
          },
          team_response_api_data => {
            if (this.props.teamFitmentResponse != "") {
              let selected_team = [];
              let selected_member_name = "";

              for (
                let i = 0;
                i < this.props.match.params.selectedTeam.split("_").length;
                i++
              ) {
                const element = this.props.match.params.selectedTeam.split("_")[
                  i
                ];
                this.state.team_data.map(obj => {
                  if (obj.id == element) {
                    selected_team.push(obj);
                  }
                });
              }

              this.state.individual_data.map(obj => {
                if (obj.id == this.props.match.params.individual) {
                  selected_member_name = obj.name;
                }
              });
              this.setState(
                {
                  selected_team_array: selected_team,
                  selected_name: selected_member_name,
                  data: dataFormater(
                    this.props,
                    this.props.teamFitmentResponse.data,
                    "team_fitment_single_team_team_member"
                  ),
                  filterApplied: "one"
                },
                () => {
                  if (
                    this.state.currentPos !== null &&
                    this.state.data.length
                  ) {
                    if (this.state.data.length > this.state.currentPos) {
                      this.onSelectIndividualTeam(
                        this.state.data[this.state.currentPos],
                        this.state.currentPos
                      );
                    } else {
                      this.onSelectIndividualTeam(this.state.data[0], 0);
                    }
                  }
                }
              );
            }
          }
        )
      );
    }
  };

  onActionInvoked(key, val) {
    this.setState({
      selected_route_parameter: key,
      Tooltip: !this.state.Tooltip,
      traceable_value: val
    });
  }

  callback() {
    this.setState({ Tooltip: false });
  }

  goToStartState(keyPos) {
    this.setState({
      filterApplied: null
    });
  }

  selectedTeamsHandler(keyPos) {
    const currentData = dataFormater(
      this.props,
      this.props.teamFitmentResponse.data,
      "team_fitment_single_team_team_member"
    );
    let currentKey = 0;
    if (keyPos === 1) {
      currentData.map((val, key) => {
        if (this.state.data[0].team_id === val.team_id) {
          if (key === 0) {
            currentKey = currentData.length - 1;
          } else {
            currentKey = key - 1;
          }
        }
      });
    } else if (keyPos === 3) {
      currentData.map((val, key) => {
        if (this.state.data[0].team_id === val.team_id) {
          if (key === currentData.length - 1) {
            currentKey = 0;
          } else {
            currentKey = key + 1;
          }
        }
      });
    }
    this.setState({
      data: keyPos === 2 ? currentData : [currentData[currentKey]],
      currentPos: keyPos === 2 ? null : currentKey,
      selected_team_name: this.findCurrentTeamName(this.state.data[0].team_id)
    });
    // this.setState({
    //     data: dataFormater(this.props,this.props.teamFitmentResponse.data,'team_fitment_single_team_team_member')
    // })
  }

  stateHandler(key) {
    this.setState({
      traceable_value: key,
      Tooltip: key == null ? false : this.state.Tooltip
    });
  }

  individualCheckFunction = e => {
    let individual_data = this.state.individual_data;
    individual_data.forEach(individual_data => {
      if (individual_data.name == e.target.value) {
        individual_data.isChecked = e.target.checked;
      } else {
        individual_data.isChecked = false;
      }
    });
    this.setState({
      active_name: e.target.value.toString(),
      individual_data: individual_data,
      collapse_individual: false
    });
  };

  teamCheckFunction = event => {
    let team_data = this.state.team_data;
    let selectedTeams = 0;

    team_data.forEach(team_data => {
      if (team_data.name == event.target.value) {
        team_data.isChecked = event.target.checked;
      }
      if (team_data.isChecked) {
        selectedTeams = 1 + selectedTeams;
      }
    });
    this.setState({ team_data: team_data, selectedTeams });
  };

  selectAllTeams = (e) => {
    let team_data = this.state.team_data;
    let selectedTeams = 0;

    team_data.forEach(team_data => {
      team_data.isChecked = e.target.checked;
      if (team_data.isChecked) {
        selectedTeams = 1 + selectedTeams;
      }
    });

    this.setState({ team_data: team_data, selectedTeams });

  }

  applyFilters = () => {
    var selected_member_id;
    this.state.individual_data.map(obj => {
      if (obj.isChecked == true) {
        selected_member_id = obj.id;
        this.setState({ selected_name: obj.name });
      }
    });
    var selected_team_id = [];
    var selected_team = [];
    var selected_team_id = this.state.team_data.map(obj => {
      if (obj.isChecked == true) {
        selected_team.push(obj);
        return obj.id;
      }
    });
    this.setState({
      selected_team_array: selected_team,
      selected_team_name: selected_team[0].name,
      filterApplied: "one"
    });
    selected_team_id = selected_team_id.filter(function(element) {
      return element !== undefined;
    });

    this.props.history.push(
      `/organisation/${
        this.props.match.params.id
      }/user/compability/${selected_member_id}/${selected_team_id.join("_")}/${
        this.state.active_role
      }`
    );
  };

  renderCustomComponent(val) {
    const arrayContent = [...this.state.data[0].array];
    return (
      <div>
        {arrayContent.map((obj, key) => {
          if (obj.header_text == val) {
            var temp = { ...obj };
            const child_contentArr = temp.child_content.map(val => {
              return {
                ...val
              };
            });
            const colaboArray = [
              {
                ...temp,
                child_content: child_contentArr
              }
            ];

            return (
              <div>
                {
                  colaboArray.map(val => {
                    return (
                      <div className="px-3 text-white">
                        <div className="background-image-recorrection" style={{ backgroundColor: val.header_background_color ? val.header_background_color : 'transparent', backgroundImage: `url(${val.header_background_image})` }}>
                          <div className="p-4 d-flex" style={{ alignItems: 'flex-end'}} >
                            <p className="mb-0">
                              {val.header_text}
                            </p>
                            <small className="pl-2">
                              {val.header_sub_text}
                            </small>
                          </div>
                        </div>
                        {
                          <div style={{maxHeight: 300, overflowY: 'auto', color: 'black'}}>
                            {
                              val.child_content.map(val1 => {
                                return (
                                  <div className="py-1">
                                    <div style={{ backgroundImage: val1.child_content_background_color }}>
                                      <div className="d-flex p-3 w-100 text-left">
                                        <h6 className="mb-0 font-weight-bold" style={{width: '20%'}}>
                                          {val1.child_header}
                                        </h6>
                                        <p className="mb-0 pl-2" style={{fontSize: 12, width: '80%'}}>
                                          {val1.child_footer_desc}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                )
                              })
                            }
                          </div>
                        }
                      </div>
                    )
                  })
                }
                
                <CircularButtonGroup
                  buttonGroupData={button_data}
                  swotCatagory={val}
                  singleButton={false}
                  onClick={this.stateHandler.bind(this)}
                  textAlign={"justify-content-end"}
                />
              </div>
            );
          }
        })}
      </div>
    );
  }

  renderReusables(data) {
    return (
      <div className="d-flex flex-row align-items-center align-self-center mx-4 p-2">
        <CircularButtonGroup
          buttonGroupData={[
            {
              img: `${data.img}`,
              name: "Compatibility",
              id: 1,
              tooltip_id: 0
            }
          ]}
          swotCatagory={1}
          singleButton={true}
          uncontrolledButton={true}
          text-align={"justify-content-start"}
        />
        <div
          className="p-2"
          style={{
            background: "linear-gradient(to right, #dbb0e0, #e6a1cb)",
            width: 100
          }}
        >
          <h6 className="mb-0 text-center font-weight-bold">{data.name}</h6>
        </div>
      </div>
    );
  }


  searchMember = (e) => {
    const filteredIndividuals = this.state.individual_data_copy.filter(individual => {
      if(individual.name.toLowerCase().includes(e.target.value.toLowerCase())) {
        return true
      }
      return false
    })

    this.setState({
      individual_data: e.target.value.length ? filteredIndividuals : this.state.individual_data_copy
    })
  }

  renderFilter() {
    return (
      <div className="d-flex flex-row justify-content-between align-items-start">
        <div
          className="filter border border-secondary rounded p-2"
          style={{ maxHeight: 300, overflowY: "scroll" }}
        >
          <div
            className="d-flex flex-row justify-content-between "
            onClick={() =>
              this.setState({
                collapse_individual: !this.state.collapse_individual
              })
            }
          >
            <h6 className="mb-0 font-weight-light" style={{ opacity: 0.7 }}>
              {this.state.active_name
                ? this.state.active_name
                : this.state.individual_data_copy.length == 0
                ? "No Team Members found"
                : "Select a team member"}
            </h6>

            {this.state.individual_data_copy.length !== 0 &&
            this.state.collapse_individual ? (
              <i className="fa fa-sort-up text-dark font-weight-bold mb-0 mt-1" />
            ) : (
              <i className="fa fa-sort-down text-dark font-weight-bold mb-1" />
            )}
          </div>
          {this.state.individual_data_copy.length !== 0 ? (
            <Collapse isOpen={this.state.collapse_individual}>
              {this.state.individual_data_copy.length == 0 ? (
                <div style={{ height: 10 }} />
              ) : (
                <React.Fragment>
                  <div className="d-flex p-1 align-items-center">
                    <i className="fa fa-search px-2" style={{color: '#797979'}}></i>
                    <input className="w-100" style={{outline: 'none'}} type="text" onChange={e => this.searchMember(e)} placeholder="Find a Member" />
                  </div>
                  {
                    this.state.individual_data.map((obj, key) => {
                      return (
                        <div key={key} className="d-flex flex-row pt-2 px-3">
                          <input
                            id={`team_member${obj.name}`}
                            type="radio"
                            style={{ cursor: "pointer" }}
                            name={obj.name}
                            value={obj.name}
                            checked={
                              this.state.active_name == `${obj.name}` ? true : false
                            }
                            onChange={e => this.individualCheckFunction(e)}
                          />
                          <label
                            for={`team_member${obj.name}`}
                            className="px-2 mb-1 cursor-pointer text-left"
                            style={{ fontSize: 14, opacity: 0.7 }}
                          >
                            {obj.name}
                          </label>
                        </div>
                      );
                    })
                  }
                </React.Fragment>
              )}
            </Collapse>
          ) : null}
        </div>
        <div
          key={this.state.team_data}
          className="filter border border-secondary rounded p-2"
          style={{ maxHeight: 300, overflowY: "scroll" }}
        >
          <div
            className="d-flex flex-row justify-content-between"
            onClick={() =>
              this.setState({ collapse_team: !this.state.collapse_team })
            }
          >
            <h6 className="mb-0 font-weight-light" style={{ opacity: 0.7 }}>
              Select Team / Teams
            </h6>
            {this.state.collapse_team ? (
              <i className="fa fa-sort-up text-dark font-weight-bold mb-0 mt-1" />
            ) : (
              <i className="fa fa-sort-down text-dark font-weight-bold mb-1" />
            )}
          </div>
          <Collapse isOpen={this.state.collapse_team}>
            {this.state.team_data.length == 0 ? (
              <div style={{ height: 10 }} />
            ) : (
              <React.Fragment>
                <div className="d-flex pt-2 px-3 border">
                  <input type="checkbox" id="__selectAllTeams" onChange={e => this.selectAllTeams(e)} />
                  <label className="px-2 mb-1 cursor-pointer" for="__selectAllTeams" style={{ fontSize: 14, opacity: 0.7 }}>Select all Teams</label>
                </div>
                {
                  this.state.team_data.map((obj, key) => {
                    return (
                      <div key={key} className="d-flex flex-row pt-2 px-3">
                        <input
                          id={`team_list${obj.name}`}
                          type="checkbox"
                          style={{ cursor: "pointer" }}
                          name={obj.name}
                          value={obj.name}
                          checked={obj.isChecked}
                          onChange={e => this.teamCheckFunction(e)}
                        />
                        <label
                          for={`team_list${obj.name}`}
                          className="px-2 mb-1 cursor-pointer"
                          style={{ fontSize: 14, opacity: 0.7 }}
                        >
                          {obj.name}
                        </label>
                      </div>
                    );
                  })
                }
              </React.Fragment>
            )}
          </Collapse>
        </div>
        <div className="filter border border-secondary rounded p-2">
          <div
            className="d-flex flex-row justify-content-between"
            onClick={() =>
              this.setState({ collapse_role: !this.state.collapse_role })
            }
          >
            <h6 className="mb-0 font-weight-light" style={{ opacity: 0.7 }}>
              Check fitment as
            </h6>
            {this.state.collapse_role ? (
              <i className="fa fa-sort-up text-dark font-weight-bold mb-0 mt-1" />
            ) : (
              <i className="fa fa-sort-down text-dark font-weight-bold mb-1" />
            )}
          </div>
          <Collapse isOpen={this.state.collapse_role}>
            {this.state.role_checkpoint.length == 0 ? (
              <div style={{ height: 10 }} />
            ) : (
              <React.Fragment>
                <div className="d-flex flex-row pt-2 px-3">
                  <input
                    id={`check_fitment_members`}
                    type="radio"
                    style={{ cursor: "pointer" }}
                    name={"Team Members"}
                    value={"team_member"}
                    checked={
                      this.state.active_role == "team_member" ? true : false
                    }
                    onChange={e =>
                      this.setState({ active_role: e.target.value.toString() })
                    }
                  />
                  <label
                    for={`check_fitment_members`}
                    className="px-2 mb-1 cursor-pointer"
                    style={{ fontSize: 14, opacity: 0.7 }}
                  >
                    Team Member
                  </label>
                </div>
                <div className="d-flex flex-row pt-2 px-3">
                  <input
                    id={`check_fitment_lead`}
                    type="radio"
                    style={{ cursor: "pointer" }}
                    name={"Team Lead"}
                    value={"team_leader"}
                    checked={
                      this.state.active_role == "team_leader" ? true : false
                    }
                    onChange={e =>
                      this.setState({ active_role: e.target.value.toString() })
                    }
                  />
                  <label
                    for={`check_fitment_lead`}
                    className="px-2 mb-1 cursor-pointer"
                    style={{ fontSize: 14, opacity: 0.7 }}
                  >
                    Team Lead
                  </label>
                </div>
                <div className="d-flex flex-row pt-2 px-3">
                  <input
                    id={`check_fitment_both`}
                    type="radio"
                    style={{ cursor: "pointer" }}
                    name={"Both"}
                    value={"both"}
                    checked={this.state.active_role == "both" ? true : false}
                    onChange={e =>
                      this.setState({ active_role: e.target.value.toString() })
                    }
                  />
                  <label
                    for={`check_fitment_both`}
                    className="px-2 mb-1 cursor-pointer"
                    style={{ fontSize: 14, opacity: 0.7 }}
                  >
                    Both
                  </label>
                </div>
              </React.Fragment>
            )}
          </Collapse>
        </div>
      </div>
    );
  }

  onSelectIndividualTeam = (data, key) => {
    this.setState({
      data: [data],
      selected_team_name: this.findCurrentTeamName(data.team_id),
      currentPos: key
    });
  };

  findCurrentTeamName = teamId => {
    let teamName = "";
    this.state.team_data.map(val => {
      if (val.id == teamId) {
        teamName = val.name;
      }
    });
    return teamName;
  };

  renderMulti_team_role() {
    return (
      <React.Fragment>
        <div className="multi-team-role">
          {this.state.data.map((val, key) => {
            return (
              <div key={key} className="d-flex flex-column m-1">
                <div className="d-flex flex-row">
                  <div className="w-50" />
                  {
                    key === 0 ?
                        this.props.match.params.role === "both" ? (
                            <div
                            className="d-flex justify-content-around"
                            style={{ width: "100%", padding: "0px 14px" }}
                            >
                                <div className="">
                                    <h6
                                    className="mb-0 w-100 mx-3 font-bold-family"
                                    style={{ fontSize: 12 }}
                                    >
                                    Team Member
                                    </h6>
                                </div>
                                <div className="">
                                    <h6
                                    className="mb-0 w-100 mx-3 font-bold-family"
                                    style={{ fontSize: 12 }}
                                    >
                                    Team Leader
                                    </h6>
                                </div>
                            </div>
                        ) : this.props.match.params.role === "team_leader" ? (
                            <div className="w-50 text-center">
                            <h6
                                className="mb-0 w-100 mx-3 font-bold-family"
                                style={{ fontSize: 12 }}
                            >
                                Team Leader
                            </h6>
                            </div>
                        ) : (
                            <div className="w-50 text-center">
                            <h6
                                className="mb-0 w-100 mx-3 font-bold-family"
                                style={{ fontSize: 12 }}
                            >
                                Team Member
                            </h6>
                            </div>
                        )
                    :
                        null
                  }
                </div>
                <div className="d-flex flex-row my-2">
                  <h6 className="mb-0 w-55 py-2 bg-white text-center font-bold-family">
                    {this.findCurrentTeamName(val.team_id)}
                  </h6>
                  {this.props.match.params.role === "both" ? (
                    <React.Fragment>
                      <h6
                        className="mb-0 w-40 py-2 ml-4 text-white text-center font-italic-family"
                        style={{
                          background:
                            val.team_member <= 10
                              ? "#bd433a"
                              : val.team_member > 10 && val.team_member <= 20
                              ? "#d8804b"
                              : val.team_member > 20 && val.team_member <= 40
                              ? "#ecc15d"
                              : val.team_member > 40 && val.team_member <= 70
                              ? "#8eb647"
                              : "#5b9440"
                        }}
                      >
                        {val.team_member <= 10
                          ? "Low"
                          : val.team_member > 10 && val.team_member <= 20
                          ? "Satisfactory"
                          : val.team_member > 20 && val.team_member <= 40
                          ? "Good"
                          : val.team_member > 40 && val.team_member <= 70
                          ? "Very Good"
                          : "Excellent"}
                      </h6>
                      <h6
                        className="mb-0 w-40 py-2 ml-4 text-white text-center font-italic-family"
                        style={{
                          background:
                            val.team_leader <= 14
                              ? "#bd433a"
                              : val.team_leader > 14 && val.team_leader <= 30
                              ? "#d8804b"
                              : val.team_leader > 30 && val.team_leader <= 45
                              ? "#ecc15d"
                              : val.team_leader > 45 && val.team_leader <= 72
                              ? "#8eb647"
                              : "#5b9440"
                        }}
                      >
                        {val.team_leader <= 14
                          ? "Low"
                          : val.team_leader > 14 && val.team_leader <= 30
                          ? "Satisfactory"
                          : val.team_leader > 30 && val.team_leader <= 45
                          ? "Good"
                          : val.team_leader > 45 && val.team_leader <= 72
                          ? "Very Good"
                          : "Excellent"}
                      </h6>
                    </React.Fragment>
                  ) : this.props.match.params.role === "team_leader" ? (
                    <h6
                      className="mb-0 w-40 py-2 ml-4 text-white text-center font-italic-family"
                      style={{
                        background:
                          val.team_leader <= 14
                            ? "#bd433a"
                            : val.team_leader > 14 && val.team_leader <= 30
                            ? "#d8804b"
                            : val.team_leader > 30 && val.team_leader <= 45
                            ? "#ecc15d"
                            : val.team_leader > 45 && val.team_leader <= 72
                            ? "#8eb647"
                            : "#5b9440"
                      }}
                    >
                      {val.team_leader <= 14
                        ? "Low"
                        : val.team_leader > 14 && val.team_leader <= 30
                        ? "Satisfactory"
                        : val.team_leader > 30 && val.team_leader <= 45
                        ? "Good"
                        : val.team_leader > 45 && val.team_leader <= 72
                        ? "Very Good"
                        : "Excellent"}
                    </h6>
                  ) : (
                    <h6
                      className="mb-0 w-40 py-2 ml-4 text-white text-center font-italic-family"
                      style={{
                        background:
                          val.team_member <= 10
                            ? "#bd433a"
                            : val.team_member > 10 && val.team_member <= 20
                            ? "#d8804b"
                            : val.team_member > 20 && val.team_member <= 40
                            ? "#ecc15d"
                            : val.team_member > 40 && val.team_member <= 70
                            ? "#8eb647"
                            : "#5b9440"
                      }}
                    >
                      {val.team_member <= 10
                        ? "Low"
                        : val.team_member > 10 && val.team_member <= 20
                        ? "Satisfactory"
                        : val.team_member > 20 && val.team_member <= 40
                        ? "Good"
                        : val.team_member > 40 && val.team_member <= 70
                        ? "Very Good"
                        : "Excellent"}
                    </h6>
                  )}
                  <i
                    className="fas w-10 fa-caret-right mb-0 mt-1 px-1"
                    style={{ fontSize: 30, cursor: "pointer" }}
                    onClick={() => {
                      this.onSelectIndividualTeam(val, key);
                    }}
                  />
                </div>
              </div>
            );
          })}
          {/* <div className="d-flex flex-row align-items-center">
                    <h6 className="mb-0 w-55"></h6>
                    <h6 className="mb-0 w-40 mx-2">Fitment as a Team Member</h6>
                    <h6 className="w-5 mb-0"></h6>
                </div>
                <div className="d-flex flex-row align-items-center m-1">
                    <h6 className="mb-0 w-55 py-2 bg-white">Team Andhra</h6>
                    <h6 className="mb-0 w-40 py-2 bg-success ml-4 text-white">Very Good</h6>
                    <i className="fa fa-caret-right text-dark font-weight-bold mb-0 w-5 py-2"></i>
                </div> */}
        </div>
        <div className="mx-5">
          <CircularButtonGroup
            buttonGroupData={[
              {
                img: compatibilityIcon,
                link: `/organisation/${
                  this.props.match.params.id
                }/user/compability`,
                name: "Compatibility",
                id: 0,
                tooltip_id: 0
              }
            ]}
            swotCatagory={0}
            singleButton={true}
            textAlign={"justify-content-end"}
            toolTip={true}
          />
        </div>
      </React.Fragment>
    );
  }

  // onChangeTeam = (teamDetails) => {
  //     const team = {
  //         "team_id": teamDetails.analytics_team_id
  //     }
  //     this.props.dispatch(analyseActions.getAssessorGroupsHandler(team, () => {
  //         this.props.dispatch(analyseActions.saveAssessorGroups(this.props.assessorGroupsResponse))
  //     }))
  // }

  doSomthing = data => {
    this.setState({ filterData: data }, () => {
      this.props.dispatch(
        analyseActions.saveAssessorGroups(this.state.filterData)
      );
    });
  };

  render() {
    const { navData, select_data } = this.state;
    const { saveAssesorGroupListResponse } = this.props;
    return (
      <div>
        <Navbar navItems={navData} backgroundColor="black" />
        <div className="container-post-nav">
          <SideNavBar
            analyzeFilterData={this.state.filterData}
            isAnalyse={true}
            organisationName={localStorage.getItem("orgName")}
            orgId={this.props.match.params.id}
            teamId={localStorage.getItem("teamId")}
            teamName={localStorage.getItem("teamName")}
            callBack={this.doSomthing.bind(this)}
            // onChangeTeam={(data) => this.onChangeTeam(data)}
          />
          <div className="analyz-container">
            <AnalysisNavBar
              analyticsData={this.props.saveModulePermissionsResponse}
              orgId={this.props.match.params.id}
              analyticsType={"people"}
            />
            {/* State dependent */}
            {this.state.filterApplied == "one" ? (
              <React.Fragment>
                {this.state.data.length == 0 ? (
                  <p className="text-center mt-4">
                    Response is empty for the selected Relations
                  </p>
                ) : (
                  <React.Fragment>
                    {this.state.data.length > 1 ? (
                      <div className="offset-xl-2 col-xl-8 offset-lg-4 col-lg-6 offset-md-1 col-md-10">
                        <h6 className="font-weight-bold d-flex justify-content-center align-items-center mb-0 px-2 py-3">
                          Compatibility of {this.state.selected_name} with the{" "}
                          {this.state.selected_team_array.map((val, key) => {
                            return `${val.name}${
                              key < this.state.selected_team_array.length - 1
                                ? ","
                                : ""
                            } `;
                          })}
                        </h6>
                        {this.renderMulti_team_role()}
                      </div>
                    ) : (
                      <React.Fragment>
                        <div className="swot-container-sub">
                          <div className="d-flex justify-content-center drop-down-container mt-5 mb-3">
                            <h6 className="d-flex justify-content-end align-items-center mb-0 px-2 ">
                              Compatibility of {this.state.selected_name} with
                              the{" "}
                              {
                                this.state.team_data.filter(
                                  team => team.id == this.state.data[0].team_id
                                )[0].name
                              }
                            </h6>
                          </div>
                          {this.state.Tooltip ? (
                              // <ModularTooltip
                              //   modalHeader={true}
                              //   toggleValue={this.state.Tooltip}
                              //   id={`TooltipExample${`${
                              //     this.state.selected_route_parameter
                              //   }`.replace(/\s/g, "")}`}
                              //   customComponent={this.renderCustomComponent(
                              //     this.state.traceable_value
                              //   )}
                              //   callbackPopover={this.callback.bind(this)}
                              //   class="gradient-popover-compatibility"
                              //   placement="top-start"
                              //   title=""
                              // /> 
                              <PopupCompitability 
                                customComponent={this.renderCustomComponent(
                                  this.state.traceable_value
                                )} />
                            ) 
                            : 
                            <div className="col- gradient-flex">
                              <div className="fitment-index-container text-center my-2">
                                <div className="d-flex flex-row flex-wrap justify-content-center">
                                  <div className="col- mt-4 mr-2 fitment-index-body">
                                    {this.state.data.length == 1 ? (
                                      <React.Fragment>
                                        {this.state.data.map((obj, key) => {
                                          var team_member = parseFloat(
                                            obj.team_member,
                                            10
                                          );
                                          var team_leader = parseFloat(
                                            obj.team_leader,
                                            10
                                          );
                                          var team_member_state = true;
                                          var team_leader_state = true;
                                          if (team_member_state) {
                                            if (
                                              team_member >= 0 &&
                                              team_member <= 10
                                            ) {
                                              team_member =
                                              //   ((team_member - 0) * 2) + 0;
                                              10
                                            } else if (
                                              team_member > 10 &&
                                              team_member <= 20
                                            ) {
                                              team_member =
                                              //   ((team_member - 10) * 2) + 20;
                                              30
                                            } else if (
                                              team_member > 20 &&
                                              team_member <= 40
                                            ) {
                                              team_member =
                                              //   ((team_member - 20) * 1) + 40;
                                              50
                                            } else if (
                                              team_member > 40 &&
                                              team_member <= 70
                                            ) {
                                              team_member =
                                              //   ((team_member - 40) * (2 / 3)) + 60;
                                              70
                                            } else if (
                                              team_member > 70 &&
                                              team_member <= 100
                                            ) {
                                              team_member =
                                              //   ((team_member - 70) * (2 / 3)) + 80;
                                              90
                                            }
                                          }
                                          if (team_leader_state) {
                                            if (
                                              team_leader >= 0 &&
                                              team_leader <= 14
                                            ) {
                                              team_leader =
                                              //   ((team_leader - 0) * (1 / 7))+ 0;
                                              10
                                            } else if (
                                              team_leader > 14 &&
                                              team_leader <= 30
                                            ) {
                                              team_leader =
                                              //   ((team_leader - 14) * (5 / 4)) + 20;
                                              30
                                            } else if (
                                              team_leader > 30 &&
                                              team_leader <= 45
                                            ) {
                                              team_leader =
                                              //   ((team_leader - 30) * (4 / 3)) + 40;
                                              50
                                            } else if (
                                              team_leader > 45 &&
                                              team_leader <= 72
                                            ) {
                                              team_leader =
                                              // ((team_leader - 45) * (20 / 27)) + 60;
                                              70

                                            } else if (
                                              team_leader > 72 &&
                                              team_leader <= 100
                                            ) {
                                              team_leader =
                                              //   ((team_leader - 72) * (10 / 14)) + 80;
                                              90
                                            }
                                          }

                                          if (
                                            this.props.match.params.role == "both"
                                          ) {
                                            return (
                                              <div className="d-flex flex-row">
                                                <div className="d-flex flex-column mx-2">
                                                  {/* <p className="mb-0 font-weight-bold">
                                                    Fitment as a
                                                  </p> */}
                                                  <h5 className="mb-0 font-italic font-weight-small">
                                                    Team Member
                                                  </h5>
                                                  <ReactSpeedometer
                                                    width={350}
                                                    height={200}
                                                    forceRender={false}
                                                    maxValue={100}
                                                    value={team_member}
                                                    needleTransition="easeBackOut"
                                                    needleTransitionDuration={
                                                      1000
                                                    }
                                                    ringWidth={39}
                                                    needleColor="black"
                                                    needleWidth={100}
                                                    startColor="#e53935"
                                                    segments={5}
                                                    endColor="rgb(0,161,38)"
                                                    role="Team Member"
                                                  />
                                                </div>
                                                <div className="d-flex flex-column mx-2">
                                                  {/* <p className="mb-0 font-weight-bold">
                                                    Fitment as a
                                                  </p> */}
                                                  <h5 className="mb-0 font-italic font-weight-small">
                                                    Team Leader
                                                  </h5>
                                                  <ReactSpeedometer
                                                    width={350}
                                                    height={200}
                                                    forceRender={false}
                                                    maxValue={100}
                                                    value={team_leader}
                                                    needleTransition="easeBackOut"
                                                    needleTransitionDuration={
                                                      1000
                                                    }
                                                    ringWidth={40}
                                                    needleColor="black"
                                                    needleWidth={100}
                                                    startColor="#e53935"
                                                    segments={5}
                                                    endColor="rgb(0,161,38)"
                                                    role="Team Leader"
                                                  />
                                                </div>
                                              </div>
                                            );
                                          } else if (
                                            this.props.match.params.role ==
                                            "team_leader"
                                          ) {
                                            return (
                                              <React.Fragment>
                                                {/* <p className="mb-0 font-weight-bold">
                                                  Fitment as a
                                                </p> */}
                                                <h5 className="mb-0 font-italic font-weight-small">
                                                  Team Leader
                                                </h5>
                                                <ReactSpeedometer
                                                  width={350}
                                                  height={200}
                                                  forceRender={false}
                                                  maxValue={100}
                                                  value={team_leader}
                                                  needleTransition="easeBackOut"
                                                  needleTransitionDuration={1000}
                                                  ringWidth={40}
                                                  needleColor="black"
                                                  needleWidth={100}
                                                  startColor="#e53935"
                                                  segments={5}
                                                  endColor="rgb(0,161,38)"
                                                  role="Team Leader"
                                                />
                                              </React.Fragment>
                                            );
                                          } else {
                                            return (
                                              <React.Fragment>
                                                {/* <p className="mb-0 font-weight-bold">
                                                  Fitment as a
                                                </p> */}
                                                <h5 className="mb-0 font-italic font-weight-small">
                                                  Team Member
                                                </h5>
                                                <ReactSpeedometer
                                                  width={350}
                                                  height={200}
                                                  forceRender={false}
                                                  maxValue={100}
                                                  value={team_member}
                                                  needleTransition="easeBackOut"
                                                  needleTransitionDuration={1000}
                                                  ringWidth={39}
                                                  needleColor="black"
                                                  needleWidth={100}
                                                  startColor="#e53935"
                                                  segments={5}
                                                  endColor="rgb(0,161,38)"
                                                  role="Team Member"
                                                />
                                              </React.Fragment>
                                            );
                                          }
                                        })}
                                      </React.Fragment>
                                    ) : null}
                                  </div>
                                </div>
                                <small className="mb-0 font-italic font-weight-small text-center font-weight-normal">
                                  The rating shown on the fitment scale is based
                                  on the number of attributes where the individual
                                  is better than the team. Make sure you carefully
                                  analyze the attributes listed under each of the
                                  following areas to better understand the
                                  individual's suitability.
                                </small>
                              </div>
                              <DynamicGradientTables
                                key={this.state.data[0].team_id}
                                classNameProps={this.state.class_name}
                                data={this.state.data[0].array.map(impacts => {
                                    return {
                                        ...impacts,
                                        child_content: impacts.child_content.filter((eachImpact, key) => key < 3)
                                    }
                                })}
                                onClick={this.onActionInvoked.bind(this)}
                              />
                              
                              <div className="d-flex flex-row justify-content-between align-items-center">
                                <div>
                                  {this.state.selectedTeams > 1 ||
                                  this.props.match.params.selectedTeam.split("_")
                                    .length > 1 ? (
                                    <CircularButtonGroup
                                      buttonGroupData={arrow_button_data}
                                      swotCatagory={""}
                                      singleButton={false}
                                      onClick={this.selectedTeamsHandler.bind(
                                        this
                                      )}
                                      textAlign={"justify-content-start"}
                                    />
                                  ) : null}
                                </div>
                                {/* <div className="py-1 px-4 bg-dark text-white">
                                                                      <h6 className="mb-0">Request MOVE</h6>
                                                                  </div> */}
                                <CircularButtonGroup
                                  buttonGroupData={single_button_data}
                                  swotCatagory={0}
                                  singleButton={true}
                                  textAlign={"justify-content-end"}
                                  onClick={this.goToStartState.bind(this)}
                                />
                              </div>
                            </div>
                          }
                        </div>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                )}
              </React.Fragment>
            ) : this.props.singleValidatorResponse ? (
              <p className="text-center">Team Members should be more than 2</p>
            ) : (
              <div
                className="swot-container-sub"
                style={{ paddingLeft: 70, paddingRight: 70 }}
              >
                {this.props.match.params.individual &&
                this.props.match.params.selectedTeam &&
                this.props.match.params.role ? (
                  <i className="fas fa-spinner fa-spin " />
                ) : (
                  <div>
                    {typeof this.props.saveAssesorIdsResponse !== "string" ? (
                      this.props.saveAssesorIdsResponse.assessmentIds.length &&
                      this.props.saveAssesorIdsResponse.assessorIds.length ? (
                        <div>
                          <h6 className="font-italic font-weight-bold text-center font-weight-normal mt-5 mb-2">
                            Analyze how well an individual fits into an existing or a new team, based
                            on the individual’s persona and the team dynamics.
                          </h6>
                          <div className="d-flex flex-row justify-content-between align-items-center">
                            {this.renderReusables({
                              img: team_fitment_indi,
                              name: "Individual"
                            })}
                            {this.renderReusables({
                              img: team_fitment_team,
                              name: "Teams"
                            })}
                            {this.renderReusables({
                              img: compatibilityIcon,
                              name: "Role"
                            })}
                          </div>
                          {this.renderFilter()}
                          <div className="d-flex justify-content-center my-4">
                            <Button
                              className="btn py-1 px-4 bg-dark text-white"
                              disabled={
                                this.state.active_name &&
                                this.state.selectedTeams &&
                                this.state.active_role
                                  ? false
                                  : true
                              }
                              style={{ cursor: "pointer" }}
                              onClick={() => this.applyFilters()}
                            >
                              <h6 className="mb-0">Apply</h6>
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <div className="d-flex justify-content-center drop-down-container m-3">
                          <p>
                            {this.props.saveAssesorIdsResponse.assessmentIds
                              .length === 0
                              ? "No Team Members Available!"
                              : "No Relations Available!"}
                          </p>
                        </div>
                      )
                    ) : null}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const saveModulePermissionsResponse = state.saveModulePermissionsReducer.data;

  const { getModulePermissionsLoading } = state.getModulePermissionsListReducer;
  const getModulePermissionsListError =
    state.getModulePermissionsListReducer.error;
  const getModulePermissionsListResponse =
    !getModulePermissionsLoading && !getModulePermissionsListError
      ? state.getModulePermissionsListReducer.data.data.message
      : "";

  const saveTeamDetailsResponse = state.saveTeamDetailsReducer.data;

  const {
    getPaUserPermissionListLoading
  } = state.getPaUserPermissionListReducer;
  const getPaUserPermissionListError =
    state.getPaUserPermissionListReducer.error;
  const getPaUserPermissionListResponse =
    !getPaUserPermissionListLoading && !getPaUserPermissionListError
      ? state.getPaUserPermissionListReducer.data.data.message
      : "";

  const { assessorGroupsLoading } = state.assessorGroupsReducer;
  const assessorGroupsError = state.assessorGroupsReducer.error;
  const assessorGroupsResponse =
    !assessorGroupsLoading && !assessorGroupsError
      ? state.assessorGroupsReducer.data.data
      : "";

  //user list
  const { userListLoading } = state.userListReducer;
  const userListError = state.userListReducer.error;
  const userListResponse =
    !userListLoading && !userListError ? state.userListReducer.data : "";

  // Team fitment
  const { teamFitmentLoading } = state.teamFitmentReducer;
  const teamFitmentError = state.teamFitmentReducer.error;
  const teamFitmentResponse =
    !teamFitmentLoading && !teamFitmentError
      ? state.teamFitmentReducer.data.data
      : "";

  //Header Permission
  const { headPerLoading } = state.headerPermissionReducer;
  const headPerLoadingError = state.headerPermissionReducer.error;
  const headPerLoadingResonse =
    !headPerLoading && !headPerLoadingError
      ? state.headerPermissionReducer.data
      : "";

  const saveAssesorGroupListResponse = state.saveAssesorGroupListReducer.data;
  const saveAssesorIdsResponse = state.saveAssesorIdsReducer.data;

  const singleValidatorResponse = state.singleValidatorReducer.data;

  //Pa analytics Team list
  const { paAnaTeamListLoading } = state.getPaAnanlyzeTeamListReducer;
  const { paAnaTeamListError } = state.getPaAnanlyzeTeamListReducer.error;
  const getPaAnanlyzeTeamListResponse =
    !paAnaTeamListLoading && !paAnaTeamListError
      ? state.getPaAnanlyzeTeamListReducer.data
      : "";

  return {
    saveModulePermissionsResponse,
    getModulePermissionsListResponse,
    saveTeamDetailsResponse,
    getPaUserPermissionListResponse,
    assessorGroupsResponse,
    saveAssesorGroupListResponse,
    saveAssesorIdsResponse,
    userListResponse,
    teamFitmentResponse,
    headPerLoadingResonse,
    headPerLoading,
    headPerLoadingError,
    getPaAnanlyzeTeamListResponse,
    paAnaTeamListError,
    paAnaTeamListLoading,
    singleValidatorResponse
  };
}

export default connect(mapStateToProps)(Compatibility);



// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/Compatibility/index.js